import { type JSX, Show } from "solid-js";
import { CatAvatar } from "@/components/CatAvatar";
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  HStack,
  Select,
  Spacer,
  Stack,
  Switch,
} from "@/components/ui";
import { setIdentityEditorOpen } from "@/state/identity";
import { currentDisplay, hasAdminRole } from "@/state/me";
import { modifierLabel, type SendKey, setAdminMode, setSendKey, settings } from "@/state/settings";

export function SettingsDialog(props: { onClose: () => void }): JSX.Element {
  const options = () => [
    { value: "modifier-enter", label: `${modifierLabel()} + Enter で送信` },
    { value: "enter", label: "Enter で送信 (改行は Shift + Enter)" },
  ];

  return (
    <Dialog open onClose={props.onClose} size="sm">
      <DialogHeader>設定</DialogHeader>
      <DialogBody>
        <Stack gap={4}>
          {/* めったに変えないので、普段の画面には出さずここに置く */}
          <Stack gap={2}>
            <span class="part-legend">あなたの猫</span>
            <HStack gap={2} align="center">
              <CatAvatar avatar={currentDisplay().avatar} size={40} label="あなたのアバター" />
              <span>{currentDisplay().name}</span>
              <Spacer />
              <Button
                variant="neutral"
                size="sm"
                onClick={() => {
                  props.onClose();
                  setIdentityEditorOpen(true);
                }}
              >
                変更する
              </Button>
            </HStack>
          </Stack>

          <Select
            label="送信キー"
            value={settings().sendKey}
            onChange={(value) => setSendKey(value as SendKey)}
            options={options()}
            hint="投稿・チャットの送信に使うキー。この端末にだけ保存されます。"
          />

          {/* 切っていても出す。切ったあとに戻せなくなるため */}
          <Show when={hasAdminRole()}>
            <Switch
              checked={settings().adminMode}
              onChange={setAdminMode}
              label="管理者モード"
              hint="切ると bot バッジや非表示ボタンが消えて、普通のユーザーと同じ見え方になります。権限は変わりません。"
            />
          </Show>
        </Stack>
      </DialogBody>
      <DialogFooter>
        <Button variant="primary" onClick={props.onClose}>
          閉じる
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
